<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="info_form">
      <el-form ref="form" :model="form" :label-width="labelWidth" :rules="rules" :inline="true">
        <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="viewMode" :config="c" :options="c.options"
          :inputValue="form[c.keyName]" @onChange="onChange" @onFileChange="onFileChange" />
      </el-form>
    </div>

    <div class="btns">
      <SubmitBtn v-if="mode != 'view'" :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">{{ mode === 'edit' ? '取 消' : '返 回' }}</el-button>
    </div>

    <canvas :id="`pdf_canvas`" style="border:1px solid #eee"></canvas>

    <!-- <div v-for="(item, i) in imgFiles" :key="i" style="margin-top:10px;position:absolute;z-index:-100;top: -9999px;">
      <canvas :id="`pdf_canvas_${item}`" style="border:1px solid #eee"></canvas>
    </div> -->
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

export default {
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: 'contract',
      breadcrumb: [
        { name: "合同管理", path: `/contract/list` },
        { name: "合同列表", path: `/contract/list` },
        { name: "合同附件" },
      ],
      form: {},
      formCtrl: [
        {
          label: '',
          keyName: 'appendix',
          type: 'file',
          // ptype: 'contract',
          btnTxt: '上传合同附件',
          tips: '合同附件仅支持图片和PDF格式，最多上传30张图片',
          accept: '.png, .jpg, .jpeg, .pdf',
          max: 30,
        },
      ],
    };
  },
  methods: {
    setDetail() {
      const { appendix } = this.detail

      this.$set(this.form, 'appendix', appendix)

      this.$forceUpdate()
      // console.log({ ...this.detail })
      // console.log({ ...this.form })
    },
    paramsPackage(params, object) {
      // console.log({ ...params }, { ...object })
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key) && key !== 'timerange') {
          params[key] = object[key];
        }
      }

      if (params.appendix && params.appendix.length == 0) {
        this.$set(params, 'appendix', null)
      }
      // console.log({ ...params }, { ...object })
    },
  },
  created() { },
  async mounted() {
    // 动态加载 pdf.js
    await this.loadPdfJs();
  },
};
</script>

<style lang="less" scoped>
.info_form {
  background-color: #fff;
  padding-top: 20px;
  padding-bottom: 5px;
  border-radius: 5px;

  /deep/ .el-form {
    margin-bottom: 20px;
    margin: 0 80px;

    .el-form-item {
      padding: 0 20px 0 0;
      margin-bottom: 20px;

      &.unton {
        width: 1000px;
      }

      &.block {
        width: 100%;
        padding-right: 0;
        margin-right: 0;
      }

      .el-input,
      .el-date-editor--daterange {
        width: 300px;
      }

      .el-form-item__content {
        .el-input {
          width: 300px;
        }

        .unit {
          color: #909399;
        }
      }

    }
  }

  .el-form:last-child {
    margin-bottom: 0;
  }
}

.btns {
  margin: 40px 0 60px 80px;
}
</style>
